<!--suppress ALL -->
<template>
  <div class="segment-panel-pages-container">
    <!--
    <div class="button-navigation" :class="[{ active: hasScrollSlides }]">
      <button
        id="button-navigation-left"
        class="  button-navigation--left btn btn-sm"
        :disabled="!hasScrollSlides"
        @click="dragSlide($event, -1)"
      >
        <i class="fa fa-angle-left" aria-hidden="true"></i>
      </button>
    </div>-->

    <div class="custom-button-navigation--left" @click="dragSlide($event, -1)">
      <svg
        viewBox="0 0 32 32"
        width="20px"
        xmlns="http://www.w3.org/2000/svg"
        style="transform: rotate(180deg)"
      >
        <g fill="#939ea7">
          <path
            d="M28.41,13.59l-10-10a2,2,0,0,0-2.82,2.82L24.17,15l-8.58,8.59a2,2,0,1,0,2.82,2.82l10-10A2,2,0,0,0,28.41,13.59Z"
          />
          <path
            d="M16.41,13.59l-10-10A2,2,0,0,0,3.59,6.41L12.17,15,3.59,23.59a2,2,0,1,0,2.82,2.82l10-10A2,2,0,0,0,16.41,13.59Z"
          />
        </g>
      </svg>
    </div>

    <div id="div-draggable-new" class="segment-panel row">
      <VuePerfectScrollbar
        id="ps-slide-wrapper-new"
        class="scroll-area"
        ref="ps"
        :use-both-wheel-axes="true"
        @ps-scroll-x="removeSmoothing"
        @ps-scroll-y="removeSmoothing"
      >
        <div class="row__inner" @mousewheel="scrollHorizontally">
          <draggable
            id="draggable-wrapper-new"
            style="display: flex;"
            v-model="list"
            @end="reorder"
            @start="getList"
            :move="dragSlide"
          >
            <transition-group name="list-new-segment">
              <div
                class="card-wrapper"
                v-for="(slide, index) in all"
                :key="'list-new-segment' + index"
                :data-uid="slide.uid"
                :data-id="slide.id"
              >
                <!--
                <div class="transition-icon-wrapper">



                  <b-button
                    v-b-modal.modal-center
                    v-show="show_transition && (index > 0 || startGeneric)"
                    class="transition-btn"
                    @click="addTransition(slide)"
                    :class="{ active: hasTransition(slide) }"
                  >
                    <i class="icon-transition"></i>
                  </b-button>

                  <b-button
                    v-show="show_video_intro && index === 0"
                    @click="videoGenerique('debut')"
                    class="transition-btn"
                    :class="{ active: startGeneric }"
                  >
                    <i class="icon-film-strip"></i>
                  </b-button>
                </div>
                -->
                <div class="index-screen">{{ index + 1 }}</div>
                <custom-panel-card
                  :typecard="'screen'"
                  :index="index"
                  :slide="slide"
                  :isSelected="slide.uid === currentSlide.uid"
                  :removable="all.length > 1"
                  :showVideoIntro="{}"
                  @selected="selectSlide(slide)"
                  @generic="videoGenerique('intro', index)"
                  @duplicated="handleDuplicateSlide(slide, index)"
                >
                </custom-panel-card>
              </div>
            </transition-group>
          </draggable>

          <div
            :class="{ disabled: all.length >= permission.nb_screen_segment && getNbSreenSegment }"
            class="folder-slide-add"
            v-on:click="showSlideListModal"
          >
            <i class="fa fa-plus"></i>
          </div>
          <!--
          <div
            :class="{ disabled: all.length >= permission.nb_screen_segment && getNbSreenSegment }"
            @click="showSlideListModal"
            class="add-segment add-new-screen"
            style="margin-top: 0;"
          >
            <i class="icon-plus"></i>
            <div style="font-size: 13px;width: 100%;">
              {{ $t('panels.addNewScreen') }}
            </div>
          </div> -->
        </div>
      </VuePerfectScrollbar>
    </div>

    <!--
    <div class="button-navigation" :class="[{ active: hasScrollSlides }]">
      <button
        id="button-navigation-right"
        class=" button-navigation--right btn btn-sm"
        :disabled="!hasScrollSlides"
        @click="dragSlide($event, 1)"
      >
        <i class="fa fa-angle-right" aria-hidden="true"></i>
      </button>
    </div>
    -->

    <div class="custom-button-navigation--right" @click="dragSlide($event, 1)">
      <svg viewBox="0 0 32 32" width="20px" xmlns="http://www.w3.org/2000/svg">
        <g fill="#939ea7">
          <path
            d="M28.41,13.59l-10-10a2,2,0,0,0-2.82,2.82L24.17,15l-8.58,8.59a2,2,0,1,0,2.82,2.82l10-10A2,2,0,0,0,28.41,13.59Z"
          />
          <path
            d="M16.41,13.59l-10-10A2,2,0,0,0,3.59,6.41L12.17,15,3.59,23.59a2,2,0,1,0,2.82,2.82l10-10A2,2,0,0,0,16.41,13.59Z"
          />
        </g>
      </svg>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import draggable from 'vuedraggable';
import VueSweetalert2 from 'vue-sweetalert2';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';

import screenService from '../../services/screen-service';
import en from '../../i18n/en_US';
import fr from '../../i18n/fr_FR';
import mixin from '../../mixins/Mixin.js';
import mixinEditors from '../../mixins/GrapesMixinEditors';
import mixinTranslate from '../../mixins/GrapesMixinTranslate';
import mixinGrapesHelpers from '../../mixins/GrapesMixinHelpers';
import GrapesMixinPanels from '../../mixins/GrapesMixinPanels';
import CustomPanelCard from './CustomPanelCard';

export default {
  mixins: [mixin, mixinEditors, mixinGrapesHelpers, GrapesMixinPanels, mixinTranslate],
  props: { isEditSegement: null },
  data() {
    return {
      list: [],
      show_video_intro: true,
      show_transition: true,
      show_generic_display: 0,
      oldValue: '',
      opened: true,
      withGeneric: true,
      currentId: null,
      title: '',
      idSelected: 0,
      typeAnimation: '',
      animation: '',
      scrollInterval: null,
      showScroll: false,
    };
  },
  components: {
    draggable,
    CustomPanelCard,
    VuePerfectScrollbar,
  },
  i18n: {
    messages: {
      en: en,
      fr: fr,
    },
  },
  computed: {
    ...mapGetters({
      all: 'slides/getSelected',
      currentSlide: 'slides/getCurrent',
      modal: 'grapes/getModal',
      paramsClient: 'getParamsClients',
      startGeneric: 'slides/getStartGeneric',
      finishGeneric: 'slides/getFinishGeneric',
      duplicateScreen: 'slides/getduplicateScreen',
      permission: 'getPermissions',
    }),
    hasScrollSlides() {
      if (this.all.length > 0) {
        let panelWidth = 0;
        let widthSlides = 0;
        let count = this.all.length;
        const cardWrapper = document.querySelector('.slide');
        if (cardWrapper) {
          widthSlides = count * cardWrapper.clientWidth * 1.4;
        }
        let panel = document.querySelector('.slides-panel');
        if (panel) {
          panelWidth = panel.offsetWidth;
        }
        if (widthSlides >= panelWidth) {
          this.showScroll = true;
        } else {
          this.showScroll = false;
        }
        return this.showScroll;
      }
    },
  },
  methods: {
    ...mapActions('slides', ['updateSlide', 'setCurrentSlide', 'duplicateSlide']),
    ...mapActions('common', ['setGenericThem', 'setOptionsThemeSelect']),

    setActiveScrollButtons() {
      if (this.all.length > 0) {
        let panelWidth = 0;
        let widthSlides = 0;
        let count = this.all.length;
        const cardWrapper = document.querySelector('.slide');
        if (cardWrapper) {
          widthSlides = count * cardWrapper.clientWidth * 1.4;
        }
        let panel = document.querySelector('.slides-panel');
        if (panel) {
          panelWidth = panel.offsetWidth;
        }
        if (widthSlides >= panelWidth) {
          this.showScroll = true;
        } else {
          this.showScroll = false;
        }
        return this.showScroll;
      }
    },
    hasTransition(slide) {
      return slide.transition.in && slide.transition.in.length > 0;
    },
    selectSlide(slide) {
      if (slide.uid === this.currentSlide.uid) {
        return;
      }
      const editor = grapesjsEMP.editors[0];
      const wrapper = editor.DomComponents.getWrapper();
      //editor.select(wrapper);
      setTimeout(() => {
        const lastSlide = {
          uid: this.currentSlide.uid,
          components: localStorage.getItem('gjs-components'),
          js: localStorage.getItem('gjs-js'),
          html: localStorage.getItem('gjs-html'),
          css: this.sanitizeCSS(localStorage.getItem('gjs-css')),
          styles: localStorage.getItem('gjs-styles'),
        };
        this.updateSlide(lastSlide);
        this.generateSlideThmbnail(this.currentSlide.uid);
        setTimeout(() => {
          this.setCurrentSlide(slide);
          this.removeToolbarCkeditor();
          this.$root.$emit('updateCanvasContent');
          this.setNoAutoplayVideo(editor);
          let videoPlayers = ['player', 'playlist'];
          videoPlayers.forEach(player => {
            this.setPausedVideo(player);
          });

          if (
            this.paramsClient.display_default_blocks &&
            Object.keys(this.paramsClient.display_default_blocks).length > 0 &&
            this.paramsClient.modules.show_list_block_action
          ) {
            const blocks = document.querySelector(
              '#gjs .gjs-pn-buttons .fa-th-large:not(.gjs-pn-active)',
            );
            if (blocks) {
              blocks.click();
            }
          }
        }, 100);
      }, 100);
    },
    handleDuplicateSlide(slide, index) {
      if (this.currentSlide.uid === slide.uid) {
        const clone = this.getClone();
        slide = Object.assign({}, this.currentSlide, clone);
      }
      this.duplicateSlide({ slide, index });


      this.selectSlide(this.duplicateScreen)


      var iconSave = document.querySelector('.icon-save');
      if (iconSave) {
        iconSave.classList.add('icon-selected');
      }
    },
    addTransition(slide) {
      this.$emit('transitionSelected', Object.assign({}, slide));
    },
    videoGenerique(generic, index) {
      var self = this;
      if (this.paramsClient.display_themes_elements != null) {
        if (generic == 'debut' && this.paramsClient.display_themes_elements.intro) {
          this.setGenericThem(this.paramsClient.display_themes_elements.intro[0].id);
          this.setOptionsThemeSelect(this.paramsClient.display_themes_elements.intro);
        }
      } else this.setGenericThem(0);
      var mdlDialog = document.querySelector('.gjs-mdl-dialog');
      eventHub.$emit('eventShowListVideo', true);
      var infoContainer = document.getElementById('list_videos');
      infoContainer.setAttribute('generic', generic);
      infoContainer.style.display = 'block';
      self.translatePluginsTitle(null, 'add_generic_intro');
      self.modal.setTitle(self.$t('blocks.add_generic_intro'));
      self.modal.setContent(infoContainer);
      document.getElementById('CanvOverlay').style.display = 'block';
      self.modal.open();
      self.modal.getModel().once('change:open', function() {
        document.getElementById('CanvOverlay').style.display = 'none';
        eventHub.$emit('eventShowListVideo', false);
      });
    },
    showSlideListModal() {
      eventHub.$emit('setShowAddScreen', true);

      //this.$root.$emit('bv::show::modal', 'segment-list-modal');
    },
    reorder(event) {
      this.reorderSlides(event);
      if (this.scrollInterval) {
        clearInterval(this.scrollInterval);
        this.scrollInterval = null;
      }
    },
  },
  mounted() {
    let self = this;
    if (this.paramsClient.show_video_intro === '0') this.show_video_intro = false;
    else this.show_video_intro = this.permission.show_intro_video_action;
    this.show_transition = this.permission.show_transition;
    this.$nextTick(() => {
      let index = 0;
      let interval = setInterval(() => {
        index++;
        this.setActiveScrollButtons();
        if (index === 10) {
          clearInterval(interval);
        }
      }, 500);
    });

    if (this.$route.params.type === 'NewSegment') {
      eventHub.$emit('setShowAddScreen', true);
    } else {
      if (this.isEditSegement) {
        localStorage.removeItem('gjs-components');
        localStorage.removeItem('gjs-html');
        self.selectSlide(self.all[0]);

        //this.$root.$emit('updateCanvasContent');
      }
    }
  },
};
</script>

<style lang="scss">
@import '../../scss/media-queries';
@import '../../scss/variables';

.segment-panel-pages-container {
  .lds-circle {
    display: inline-block;
    width: 15px;
    height: 15px;
    border-radius: 50%;
    background: rgb(59, 151, 227);
    animation: lds-circle 2.4s cubic-bezier(0, 0.2, 0.8, 1) infinite;
  }
  @keyframes lds-circle {
    0%,
    100% {
      animation-timing-function: cubic-bezier(0.5, 0, 1, 0.5);
    }
    0% {
      transform: rotateY(0deg);
    }
    50% {
      transform: rotateY(1800deg);
      animation-timing-function: cubic-bezier(0, 0.5, 0.5, 1);
    }
    100% {
      transform: rotateY(3600deg);
    }
  }

  .drag-wrapper {
    display: flex;
    justify-content: center;
  }

  .list-complete-enter,
  .list-complete-leave-active {
    opacity: 0;
  }

  @keyframes nodeInserted {
    from {
      opacity: 0.2;
    }
    to {
      opacity: 0.8;
    }
  }

  .item-dropzone-area {
    height: 2rem;
    background: #888;
    opacity: 0.8;
    animation-duration: 0.5s;
    animation-name: nodeInserted;
  }
  .panel__devices {
    position: initial;
  }

  .list_page {
    height: 90%;
    overflow: overlay;
  }

  div span {
    display: flex;
  }
  #div-draggable-new {
    overflow-x: auto;
    overflow-y: hidden;
    margin: 0 5px !important;
    flex-grow: 1;
  }
  .btn-delete-dep {
    font-size: 15px !important;
  }
  .button_screen {
    position: fixed;
    width: 260px;
    bottom: 0px;
    color: rgb(255, 255, 255);
    background-color: rgb(59, 151, 227);
    padding-bottom: 33px;
    border: none;
    font-size: 15px;
    left: 40px;
    -webkit-transition: all 0.15s ease 0s;
    transition: all 0.15s ease 0s;
  }

  .row__inner {
    margin: 0;
    padding-bottom: 5px;
    display: flex;
    .card-wrapper {
      display: flex;
      align-items: center;
      flex-direction: row;
      width: $width-folder + 30;
    }
  }

  ::-webkit-scrollbar {
    width: 7px;
    height: 7px;
  }

  ::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px #b2b2b2;
    border-radius: 5px;
  }

  ::-webkit-scrollbar-thumb {
    background: #b2b2b2;
    border-radius: 5px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #b2b2b2;
  }
  .gjs-pn-views .gjs-pn-btn {
    width: 16% !important;
    min-width: 35px !important;
    border-bottom: 0 !important;
  }
  .gjs-pn-views-container .gjs-pn-btn {
    width: 16% !important;
    min-width: 35px !important;
    border-bottom: 0 !important;
  }
  .gjs-pn-buttons {
    display: inline !important;
  }
  #gjs-pn-commands .gjs-pn-buttons,
  .gjs-pn-commands .gjs-pn-buttons {
    display: none !important;
  }
  .gjs-pn-panel.gjs-pn-views {
    margin-right: -43px !important;
  }
  .gjs-pn-panel#gjs-pn-views-container,
  .gjs-pn-panel.gjs-pn-views-container {
    height: calc(100% - 210px) !important;
    bottom: 125px;
  }
  .gjs-asset-manager {
    display: flex;
    flex-direction: row;
    height: 400px;
    margin: 15px;
    height: 100%;
    display: flex;
    flex-direction: column;
  }
  .item-li {
    /*margin: 5px;*/
    color: #fff;
  }

  body.custom_body.swal2-height-auto {
    height: 100% !important;
  }
  .transition-icon {
    width: 1.2rem;
  }
  /* always present */
  .expand-transition {
    transition: all 0.3s ease;
    height: 30px;
    padding: 10px;
    background-color: #eee;
    overflow: hidden;
  }
  /* .expand-enter defines the starting state for entering */
  /* .expand-leave defines the ending state for leaving */
  .expand-enter,
  .expand-leave {
    height: 0;
    padding: 0 10px;
    opacity: 0;
  }
  .modal-active {
    display: block;
  }
  .transition-btn {
    border: none !important;
    padding: 0 !important;
    width: 30px !important;
    height: 30px !important;
    background-color: transparent !important;
    opacity: 0.6;
    margin: 0 0 0 10px !important;
    color: #3c5875 !important;
    font-size: 1.6em !important;
    &.active {
      opacity: 1;
    }
  }
  .transition-btn:hover,
  .transition-btn:active,
  .transition-btn:focus {
    background-color: transparent !important;
    border-color: transparent !important;
    box-shadow: none !important;
  }

  .add-new-screen {
    margin-top: 0px !important;
    width: 160px !important;
    height: 90px !important;
    margin: 0 10px !important;
    background: transparent !important;
    border: 1px dashed #2196f3;
    color: #2196f3;
    transition: 0.2s;
    i {
      font-size: 32px;
    }
    &:hover {
      background-color: #2196f3 !important;
      color: #ffffff;
    }
    &.disabled {
      cursor: not-allowed;
      opacity: 0.3;
      background: transparent !important;
      color: #2196f3;
    }
    &.disabled:active {
      pointer-events: none;
    }
  }

  .scroll-area {
    padding: 12px 15px;
    margin-left: -10px;
  }
  .resize-elements {
    width: calc(100% - 230px) !important;
  }
  .transition-icon-wrapper {
    height: 90px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
  .custom-button-navigation {
    &--right {
      cursor: pointer;
      width: 30px;
      height: $height-custom-panel;
      color: #939ea7;
      border-left: 2px solid #939ea7 !important;
      border-right: 1px solid #939ea7 !important;
      svg {
        margin-top: $height-custom-panel/2 - 6;
        width: 12px;
      }
    }
    &--left {
      cursor: pointer;
      border-left: 1px solid #939ea7 !important;
      border-right: 2px solid #939ea7 !important;
      width: 30px;
      height: $height-custom-panel;
      color: #939ea7;
      svg {
        margin-top: $height-custom-panel/2 - 6;
        width: 12px;
      }
    }
    i {
      color: #939ea7;
      width: 1em;
    }
    &.active {
      background-color: #ffffff !important;
      color: #2196f3 !important;
      border: 2px solid #2196f3 !important;
      i {
        background-color: #ffffff !important;
        color: #2196f3 !important;
      }
    }
  }
}

.folder-slide-add {
  margin-left: 10px;
  width: $width-folder - 2;
  height: $height-folder + 4;
  border-radius: 3px 3px 3px 3px;
  background-color: #2d73bc82;
  cursor: pointer;
  display: flex;
  align-items: center;
  margin: 2px 0;
  i.fa.fa-plus {
    color: #7ea4cb;
    font-size: 34px;
    height: calc(100% - 10px);
    width: calc(100% - 10px);
    border-top-style: dashed;
    border-bottom-style: dashed;
    border-width: 3px;
    border-color: white;
    margin: 5px;
    padding: 12px;
  }
}

.segment-panel-pages-container {
  .index-screen {
    font-size: 17px;
    margin-right: 3px;
    margin-top: 0px !important;
  }
  .item-li {
    color: #939ea7;
    font-size: 20px;
  }
  .scroll-area {
    padding: 5px 15px;
    margin-left: -10px;
  }
}

.open-menu-style {
  background: #8d8d8d;
  color: white !important;
  border: 1px solid #8d8d8d;
  border-radius: 100%;
  padding: 2px;
  &.fa-ellipsis-v {
    transform: rotate(90deg);
  }
}

.segment-panel-pages-container .item-li {
  color: #8d8d8d !important;
  font-size: 1.2em !important;
  &.open-menu-style {
    background: #ffff00; //#2d73bc;
    color: #8d8d8d !important;
    border: 1px solid #ffff00; //#2d73bc;
    border-radius: 2px;
    border-bottom-left-radius: 7px;
    padding: 2px;
    &:hover {
      background: #144088;
      color: white !important;
      border: 1px solid #144088;
    }
    &.fa-ellipsis-v {
      transform: rotate(90deg);
      position: absolute;
      bottom: 0;
      right: 0;
      &:before {
        padding: 7px;
      }
    }
  }
}


</style>



// WEBPACK FOOTER //
// CustomSegmentPanelPages.vue?6308e450